import { VueController } from '../util/vue_controller'

// Connects to data-controller="activity-distributors"
export default class extends VueController {
  static outlets = ['form', 'form-confirmation']

  static targets = ['grid']

  static values = {
    distributors: Array,
    existing: Array
  }

  static vueComponent = 'activity-distributors'

  get props () {
    return {
      distributors: this.distributorsValue,
      savedData: this.existingValue
    }
  }

  get vueTarget () {
    return this.gridTarget ?? super.vueTarget
  }

  handleEvent (eventName, data) {
    if (eventName === 'form-validity-changed') {
      if (data.isValid) {
        this.formOutlet.markAsValid()
      } else {
        this.formOutlet.markAsInvalid()
      }
    } else if (eventName === 'form-values-changed') {
      this.formConfirmationOutlet.extraFormValuesValue = data.selectedDistributors
    }
  }
}
